import { render, staticRenderFns } from "./logisticsAchievements.vue?vue&type=template&id=4cffba7c&scoped=true&"
import script from "./logisticsAchievements.vue?vue&type=script&lang=js&"
export * from "./logisticsAchievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffba7c",
  null
  
)

export default component.exports